import React, { useState, useEffect } from 'react';

export function AnimatedWord({ word, delay = 0, initialDelay = 0, onAnimationComplete }) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [currentWord, setCurrentWord] = useState(word.original);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const readyTimer = setTimeout(() => {
      setIsReady(true);
    }, initialDelay);

    return () => clearTimeout(readyTimer);
  }, [initialDelay]);

  useEffect(() => {
    if (!isReady) return;

    const timer = setTimeout(() => {
      // Start flip
      setIsFlipped(true);
      
      // Halfway through the flip, change the word
      const wordChangeTimer = setTimeout(() => {
        setCurrentWord(word.replacement);
        setIsFlipped(false);
        onAnimationComplete?.();
      }, 300); // Half of flip duration (600ms total)

      return () => clearTimeout(wordChangeTimer);
    }, delay);

    return () => clearTimeout(timer);
  }, [word, delay, onAnimationComplete, isReady]);

  if (!isReady) {
    return <div className="font-semibold w-full h-full flex items-center justify-center uppercase">{word.original}</div>;
  }

  return (
    <div className="w-full h-full perspective">
      <div
        className={`w-full h-full transition-all duration-600 ease-in-out transform ${
          isFlipped ? 'rotate-x-90' : 'rotate-x-0'
        }`}
        style={{
          transformStyle: 'preserve-3d',
        }}
      >
        <div className="font-semibold w-full h-full flex items-center justify-center uppercase">
          {currentWord}
        </div>
      </div>
    </div>
  );
}

export default AnimatedWord;
